<template>
  <v-card outlined elevation="2">
    <v-card-title class="subtitle-1">
      <template>
        <span class="pr-2">{{ schedule.description }}</span>
      </template>
    </v-card-title>
    <v-card-text class="pt-0">
      <v-row wrap>
        <v-col class="py-0" cols="4">
          <DisplayField label="Premium" :value="premium" />
        </v-col>
        <v-col class="py-0" cols="4">
          <DisplayField label="Deductible" :value="schedule.deductible" type="currency" />
        </v-col>
        <v-col class="py-0" cols="4">
          <DisplayField label="Limit" :value="schedule.limit" type="number" />
        </v-col>
        <v-col class="py-0" cols="12">
          <DisplayField label="Valuation" :value="valuation" />
        </v-col>
        <template v-if="isUnscheduledSchedule">
          <v-col class="py-0" cols="4">
            <DisplayField label="Cause Of Loss" :value="schedule.causeOfLoss" />
          </v-col>
          <v-col class="py-0" cols="4">
            <DisplayField label="Max Item" :value="schedule.maxItemValue" />
          </v-col>
          <v-col class="py-0" cols="6">
            <DisplayField label="Policy Coinsurance" :value="policyCoinsurancePercentage" />
          </v-col>
          <v-col class="py-0" cols="6">
            <DisplayField label="Cur. Coinsurance" :value="schedule.currentCoinsurance" />
          </v-col>
        </template>

      </v-row>
    </v-card-text>
    <v-card-actions class="pt-0">
      <v-spacer />
      <v-btn color="blue2" outlined small @click="openScheduledItems">{{ isUnscheduledSchedule ? 'Unscheduled Items' : 'Scheduled Items' }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<style scoped>
</style>

<script>
import DisplayField from '@/components/Shared/DisplayField.vue';
import displayFormatterService from '@/services/shared/displayFormatterService.js';
import enumService from '@/services/shared/enumService.js';

export default {
  name: 'ScheduleCard',
  components: { DisplayField },
  props: {
    schedule: {
      type: Object,
      default: null
    }
  },
  computed: {
    isUnscheduledSchedule: function () {
      if ((this.schedule.unscheduledItems || null) !== null) {
        return this.schedule.unscheduledItems.length > 0;
      }
      return false;
    },
    premium: function () {
      if ((this.schedule || null) === null) return displayFormatterService.formatCurrency(0);
      return displayFormatterService.formatCurrency(this.schedule.premium);
    },
    policyCoinsurancePercentage: function () {
      return (this.schedule.coinsurancePercent || null) === null ? '' : this.schedule.coinsurancePercent + '%';
    },
    valuation: function () {
      return enumService.scheduleValuationType[this.schedule.valuation];
    }
  },
  methods: {
    openScheduledItems: function () {
      this.$emit('openScheduledItemsDialog');
    }
  }
};
</script>
